/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyOutput {
    getFixupPrototypeFunction() { return PolicyOutput.fixupPrototype; }

    static newInstance(model: Partial<PolicyOutput>): PolicyOutput {
        let obj = Object.assign(new PolicyOutput(), model);
        PolicyOutput.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyOutput>): PolicyOutput {
        if (!model) return null;
        return PolicyOutput.newInstance(<PolicyOutput> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyOutput) {
        if (!obj) return;

        models.PolicyOutput.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyOutput): boolean {
        Object.setPrototypeOf(obj, PolicyOutput.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.violated_resources_count === undefined) {
            this.violated_resources_count = 0;
        }
        if (this.evaluated_resources_count === undefined) {
            this.evaluated_resources_count = 0;
        }
    }

    /**
     * Execution status of the policy
     */
    policy_execution_status: models.PolicyJobStatus;

    /**
     * Unique ID for the policy
     */
    policy_id: string;

    /**
     * Unique URI for the policy
     */
    policy_uri: string;

    /**
     * Unique ID for the policy job
     */
    policy_job_id: string;

    /**
     * Count of resources that violated the policy
     */
    violated_resources_count: number;

    /**
     * Count of resources evaluated by the policy
     */
    evaluated_resources_count: number;

    /**
     * Type of resource evaluated
     */
    resource_type: string;

}
